module.exports = __webpack_public_path__ + "static/img/a4.d1f0ebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/a4.png
// module id = VuCd
// module chunks = 1